import React, { useEffect, useState } from 'react';
import Styles from './styles.module.sass';
import Slider from 'react-slick';

const ModuleBanners = () => {

    const [ bannerSection, setBannerSection ] = useState([])
    const getBanners = async () => {
        const hosts = "https://resources.sears.com.mx/"
        const api = `${hosts}medios-plazavip/swift/v1/Sears/credito/nuevoCredito/home/promociones_credito.json`

        const config = {
            method: 'get',
            redirect: 'follow',
            timeout: 25
        }

        try {
            const response = await fetch(api, config);
            const data = await response.json();
            const responseData = data?.sections[0].items || [];
            const responseOrderData = responseData?.sort((a, b) => a.order - b.order) || [];
            setBannerSection(responseOrderData)

        } catch (error) {
            console.error("Error fetching banners:", error);
            return [];
        }
    }

    const settingsInf = {
        dots: false,
        autoplay: true,
        infinite: true,
        dotsClass: Styles?.dotsSliders,
        className: Styles?.slideSlidersInf,
        centerMode: false,
        swipe: true,
        touchMove: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        speed: 700,
        captions: true,
        responsive: [
            {
                breakpoint: 780,
                settings: {
                    slidesToShow: 1,
                    speed: 700,
                }
            }
        ]
    };

    useEffect(() => {
        getBanners()
    }, [])

    return(
        bannerSection?.length > 0 && (
            <div className={`${Styles?.contBanners} ${Styles?.cardStyle}`}>
                <div className={Styles.contBannersCards}>
                    <Slider {...settingsInf}>
                        {bannerSection.map(banner => (
                            banner?.url
                                ?
                                    <a key={banner?.order} href={banner?.url} target={banner?.target ? banner?.target : "_self"} rel="noopener noreferrer">
                                        <img src={banner?.img} alt={banner.name} loading="lazy" width="386" height="267" importance="low" />
                                    </a>
                                :
                                    <img src={banner?.img} alt={banner?.name} loading="lazy" width="386" height="267" importance="low" />
                        ))}
                    </Slider>
                    <div className={Styles?.conocePromos}>Conoce nuestras promociones</div>
                </div>
            </div>
        )

    )
}
export default ModuleBanners;